<template>
    <div class="voucher">
        <div v-if="showInput === false" class="show-input">
            <span @click="showInput = true">{{ translations['I have a voucher'] }}</span>
        </div>
        <div v-if="showInput">
            <div class="input-group">
                <input v-model="voucherCode" @keyup.enter="applyVoucher" type="text" class="form-control" :placeholder="translations['Voucher']"/>
                <div class="input-group-append">
                    <button @click="applyVoucher" type="button" class="button">{{ translations['Ok'] }}</button>
                </div>
            </div>
            <span v-if="isInvalid" class="invalid-voucher">{{ translations['Voucher is invalid'] }}</span>
        </div>
        <div v-for="voucher in this.vouchers" class="vouchers-list">
            <div class="row">
                <div class="col-6">
                    {{ voucher.code }} <strong @click="removeVoucher(voucher.code)" class="remove-voucher-button" :title="translations['Delete voucher']"> &times;</strong>
                </div>
                <div class="col-6 text-right">
                    {{ voucher.value }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';

    export default {
        name: 'Voucher',
        data () {
            return {
                voucherCode: null,
                isInvalid: false,
                showInput: false
            }
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                vouchers: state => state.voucher.vouchers,
            }),
            showVoucherInput: function () {
                return true;
            },
        },
        methods: {
            applyVoucher: function () {
                this.$store.dispatch('voucher/apply', this.voucherCode)
                    .then((result) => {
                        if (result === false) {
                            this.isInvalid = true;
                            return;
                        }
                        this.isInvalid = false;
                        this.showInput = false;
                        this.voucherCode = '';
                    })
            },
            removeVoucher: function (code) {
                this.$store.dispatch('voucher/remove', code)
            }
        }
    }
</script>
<style scoped lang="scss">
    .voucher {
        font-size: 16px;
        color: #f2b508;
        text-transform: none;
        .show-input {
            cursor: pointer;
        }

        .invalid-voucher {
            font-size: 12px;
            font-weight: 400;
            color: #da2626;
        }
        .vouchers-list {
            font-size: 21px;
            color: #212529;
            @media (max-width: 1349px) {
                font-size: 18px;
            }
            .remove-voucher-button {
                color: #da2626;
                cursor: pointer;
            }
        }

        input {
            border-color: #bdbdbd;
            max-width: 200px;
            &:active, &:focus {
                outline: none;
                box-shadow: none;
            }
        }


        button {
            border: none;
            margin: 0;
            padding: 0 10px;
            background-color: #f2b508;
            text-transform: uppercase;
            color: white;
            font-size: 16px;
            font-weight: 700;
        }
        @media (max-width: 1349px) {
            font-size: 14px; 
        }
    }
</style>
